// extracted by mini-css-extract-plugin
export var alertIcon = "_tr-0";